(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Event delegation, så scriptet virker for alle instanser af sektionen
  // og overlever gensnedning i temaeditoren uden gen-initialisering.

  function getRoot(el) {
    return el.closest('[data-gallery-root]');
  }

  function getTriggers(root) {
    return Array.from(root.querySelectorAll('[data-gallery-trigger]'));
  }

  function openModal(root, trigger) {
    var dialog = root.querySelector('[data-gallery-modal]');
    var img = dialog.querySelector('[data-gallery-modal-image]');
    var captionEl = dialog.querySelector('[data-gallery-modal-caption]');

    setModalContent(dialog, trigger);

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'true');
    }
  }

  function setModalContent(dialog, trigger) {
    var img = dialog.querySelector('[data-gallery-modal-image]');
    var captionEl = dialog.querySelector('[data-gallery-modal-caption]');
    var caption = trigger.getAttribute('data-caption') || '';

    img.src = trigger.getAttribute('data-full-src');
    img.width = trigger.getAttribute('data-full-width');
    img.height = trigger.getAttribute('data-full-height');
    img.alt = trigger.querySelector('img') ? trigger.querySelector('img').alt : '';

    dialog.dataset.activeTrigger = String(getTriggers(getRoot(trigger)).indexOf(trigger));

    if (caption) {
      captionEl.textContent = caption;
      captionEl.hidden = false;
    } else {
      captionEl.textContent = '';
      captionEl.hidden = true;
    }
  }

  function closeModal(dialog) {
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function step(root, direction) {
    var dialog = root.querySelector('[data-gallery-modal]');
    var triggers = getTriggers(root);
    if (!triggers.length) return;

    var currentIndex = parseInt(dialog.dataset.activeTrigger || '0', 10);
    var nextIndex = (currentIndex + direction + triggers.length) % triggers.length;
    setModalContent(dialog, triggers[nextIndex]);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-gallery-trigger]');
    if (trigger) {
      var root = getRoot(trigger);
      if (root) openModal(root, trigger);
      return;
    }

    var closeBtn = event.target.closest('[data-gallery-close]');
    if (closeBtn) {
      var dialogFromClose = closeBtn.closest('[data-gallery-modal]');
      if (dialogFromClose) closeModal(dialogFromClose);
      return;
    }

    var prevBtn = event.target.closest('[data-gallery-prev]');
    if (prevBtn) {
      var rootPrev = getRoot(prevBtn);
      if (rootPrev) step(rootPrev, -1);
      return;
    }

    var nextBtn = event.target.closest('[data-gallery-next]');
    if (nextBtn) {
      var rootNext = getRoot(nextBtn);
      if (rootNext) step(rootNext, 1);
      return;
    }

    // Klik på selve dialog-elementet (uden for .image-gallery__modal-inner) = luk (light dismiss)
    var openDialog = event.target.closest('dialog[data-gallery-modal]');
    if (openDialog && event.target === openDialog) {
      closeModal(openDialog);
    }
  });

  document.addEventListener('keydown', function (event) {
    var openDialog = document.querySelector('dialog[data-gallery-modal][open]');
    if (!openDialog) return;

    var root = getRoot(openDialog);
    if (!root) return;

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      step(root, 1);
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      step(root, -1);
    }
    // Escape lukkes automatisk af native <dialog> via 'cancel'-eventet
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-instagram-sound-toggle]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const media = btn.closest('.instagram-feed__media');
      const video = media ? media.querySelector('[data-instagram-video]') : null;
      if (!video) return;

      video.muted = !video.muted;
      btn.setAttribute('aria-pressed', String(!video.muted));
      btn.setAttribute('aria-label', video.muted ? 'Slå lyd til' : 'Slå lyd fra');
      btn.innerHTML = video.muted
        ? document.getElementById('instagram-feed-icon-muted-template').innerHTML
        : document.getElementById('instagram-feed-icon-unmuted-template').innerHTML;
    });
  });

  // "Se mere..." skal kun vises hvis teksten faktisk er trunkeret af line-clamp.
  // Vi måler scrollHeight vs. clientHeight efter render for at afgøre det reelt,
  // i stedet for at vise knappen statisk uanset tekstlængde.
  const initCaptionToggles = () => {
    document.querySelectorAll('[data-instagram-caption]').forEach((wrap) => {
      const textEl = wrap.querySelector('[data-caption-text]');
      const seeMoreBtn = wrap.querySelector('[data-see-more]');
      if (!textEl || !seeMoreBtn) return;

      // Spring over hvis brugeren allerede har udvidet teksten (undgå at
      // en resize skjuler knappen igen midt i en åben visning).
      if (textEl.classList.contains('is-expanded')) return;

      const isTruncated = textEl.scrollHeight > textEl.clientHeight + 1;
      seeMoreBtn.hidden = !isTruncated;
    });
  };

  document.querySelectorAll('[data-see-more]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const wrap = btn.closest('[data-instagram-caption]');
      const textEl = wrap ? wrap.querySelector('[data-caption-text]') : null;
      if (!textEl) return;

      const expanded = textEl.classList.toggle('is-expanded');
      btn.textContent = expanded ? 'Vis mindre' : 'Se mere...';
    });
  });

  // Fonte kan indlæses asynkront og ændre tekst-højden, så vi tjekker
  // både ved DOMContentLoaded og igen når skrifttyper er klar.
  initCaptionToggles();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initCaptionToggles);
  }
  window.addEventListener('resize', initCaptionToggles);
});

  } catch(e) { console.error(e); }
})();
})();
